import { Component, OnInit } from '@angular/core';
import { ContentService } from '../services/content.service';
import { SocialAccountService } from '../services/social-account.service';
import { WorkEffortService } from '../services/work-effort.service';
import { SocialMediaService } from '../services/social-media.service';
import { FormsModule } from '@angular/forms';
import { ComponentTask, getFields, getFieldSets, getTarget, getTargets, Lookup, Relation, SelectorType, UbsComponentStoreService } from '@urbannex/view-containers';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { MKTING_FORMS } from '../forms';

@Component({
  selector: 'ngx-social-media-posting',
  templateUrl: './social-media-posting.component.html',
  styleUrls: ['./social-media-posting.component.scss']
})

export class SocialMediaPostingComponent implements OnInit {
  content: any = {};
  socialAccounts: any[] = [];
  selectedPlatform: string;
  selectedContentType: string;
  selectedWorkEffortType: string;
  platforms = ['Facebook', 'X (Twitter)', 'Instagram', 'Google'];
  contentTypes = ['text', 'image', 'video'];
  workEffortTypes = ['immediate', 'scheduled'];

  selectedType: 'product' | 'article' = 'product';
  selectedId: string = '';
  description: string = '';
  images: string[] = [];
  selectedImage: string = '';
  scheduledDate: string = '';
  scheduledTime: string = '';
  
  selectedPlatforms: string[] = [];

  componentTask:ComponentTask = {
    title: "Sechedule a Social Media Post",
    path: '',
    selector: {
      title: 'Post Scheduled Today',
      type: SelectorType.LIST,
      source: new OfbizList({
        listFormName: "SocialMediaCurrentPostingList",
        columnFieldTitles:getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
        emptyListMessage: "No social media postings available",
        listFormLocation: "SocialMediaCurrentPostingList",
        columnFields: getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
        remoteFormData: {
          formData: {
            formName: "SocialMediaCurrentPostingList",
            formLocation: "component://kwikstore/widget/MarketingForms.xml",
            listType: "grid",
            entityName: "",
            viewIndex: 0,
            viewSize: 0
          }
        }
      })
    },
    updater:{
      title: 'Schedule A New Social Media Pst',
      updateActions:[
        {
          title: 'Schedule A New Social Media Post',
          condition:null,
          isDefault:true,
          updateForm: new OfbizForm({
            title:'Schedule A New Social Media Post',
            formName:"CreateSocialMediaProductPost",
            local:true,
            formLocation:"component://kwikstore/widget/MarketingForms.xml",
            fields:getFields("CreateSocialMediaProductPost",MKTING_FORMS),
            fieldSets:getFieldSets("CreateSocialMediaProductPost",MKTING_FORMS),
            appContext:"kwikstore",
            targets:getTargets("CreateSocialMediaProductPost",MKTING_FORMS),
            target:getTarget("CreateSocialMediaProductPost",MKTING_FORMS),
            layout:"vertical"
          })
        },
        {
          title: 'Edit Social Media POst',
          isDefault:false,
          condition: { field: "workEffortId", operator: "not-equal", value: null },
          updateForm: new OfbizForm({
            formName:"UpdateSocialMediaPost",
            local:true,
            appContext:"kwikstore",
            formLocation:"component://kwikstore/widget/MarketingForms.xml",
            fields:getFields("UpdateSocialMediaPost",MKTING_FORMS),
            fieldSets:getFieldSets("UpdateSocialMediaPost",MKTING_FORMS),
            targets:getTargets("UpdateSocialMediaPost",MKTING_FORMS),
            target:getTarget("UpdateSocialMediaPost",MKTING_FORMS),
            layout:"vertical",
            breadCrumbData:{

            }
          })
        }
      ]
    },
    effect: {
      title: 'Post Summary',
      result: new OfbizList({
        listFormName: "SocialMediaCurrentPostingList",
        columnFieldTitles:getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
        emptyListMessage: "No social media postings available",
        listFormLocation: "SocialMediaCurrentPostingList",
        columnFields: getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
        remoteFormData: {
          formData: {
            formName: "SocialMediaCurrentPostingList",
            formLocation: "component://kwikstore/widget/MarketingForms.xml",
            listType: "grid",
            entityName: "",
            viewIndex: 0,
            viewSize: 0
          }
        }
      })
    }
  }

  relation:Relation = {
    addContainerTitle: 'Add Social Media Post',
    listContainerTitle: 'Posts Sceduled Today',
    keyMap: undefined,
    addFormName: '',
    listFormName: '',
    addForm: new OfbizForm({
      formName:"CreateSocialMediaProductPost",
      local:true,
      formLocation:"component://kwikstore/widget/MarketingForms.xml",
      fields:getFields("CreateSocialMediaProductPost",MKTING_FORMS),
      fieldSets:getFieldSets("CreateSocialMediaProductPost",MKTING_FORMS),
      appContext:"marketing",
      targets:getTargets("CreateSocialMediaProductPost",MKTING_FORMS),
      target:getTarget("CreateSocialMediaProductPost",MKTING_FORMS),
      layout:"vertical"
    }),
    listForm: new OfbizList({
      listFormName: "SocialMediaCurrentPostingList",
      columnFieldTitles:getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
      emptyListMessage: "No social media postings available",
      listFormLocation: "SocialMediaCurrentPostingList",
      columnFields: getFields("SocialMediaCurrentPostingList",MKTING_FORMS),
      remoteFormData: {
        formData: {
          formName: "SocialMediaCurrentPostingList",
          formLocation: "component://kwikstore/widget/MarketingForms.xml",
          listType: "grid",
          entityName: "",
          viewIndex: 0,
          viewSize: 0
        }
      }
    })
  }
  /**
   * fieldFormName:string
       findFormName:string;
       resultListName:string;
       requestingField?:OfbizField;
       lookedUpValueFieldName?:string;
       lookedUpValue?:any;
       lookedUpDescritionFieldName?:string;
       lookedUpDescription?:any;
   */
  relations:[Relation] = [this.relation];
  tasks:[ComponentTask] = [this.componentTask];
  
  selectedValue;

  constructor(
    private componentStore: UbsComponentStoreService,
    private contentService: ContentService, 
    private workEffortService: WorkEffortService,
    private socialAccountService: SocialAccountService,
    private socialMediaService: SocialMediaService
  ) {}

  ngOnInit() {
    this.componentStore.updateSelectedTask(this.componentTask);
    this.componentStore.updateSelectedRelation(this.relation);
    this.selectedPlatform = 'facebook'; // Default platform
    this.selectedContentType = 'text'; // Default content type
    this.selectedWorkEffortType = 'scheduled'; // Default work effort type
  }

  loadSocialAccounts() {
    this.socialAccountService.getSocialAccount('Facebook').subscribe(accounts => {
      this.socialAccounts = accounts;
    });
  }


  createPost() {
    this.contentService.postContentToSocialMedia(
      this.content, 
      this.selectedPlatform, 
      this.selectedContentType, 
      this.selectedWorkEffortType
    ).subscribe(response => {
      // Handle success
      console.log('Post created:', response);
    }, error => {
      // Handle error
      console.error('Error creating post:', error);
    });
  }

  fetchContentDetails(): void {
    if (!this.selectedId) return;

    this.socialMediaService.getContentDetails(this.selectedId, this.selectedType)
      .subscribe(response => {
        this.description = response.description;
        this.images = response.images;
        this.selectedImage = this.images.length ? this.images[0] : '';
      });
  }

  schedulePost(): void {
    if (!this.selectedId || !this.selectedImage || !this.scheduledDate || !this.scheduledTime || this.selectedPlatforms.length === 0) {
      alert('Please fill all required fields.');
      return;
    }

    const postData = {
      contentId: this.selectedId,
      type: this.selectedType,
      description: this.description,
      imageUrl: this.selectedImage,
      scheduledDateTime: new Date(`${this.scheduledDate}T${this.scheduledTime}:00`),
      platforms: this.selectedPlatforms
    };
    /**
     * Todo
     * Choose one of the following services
     */
     // Logic to schedule a post (use SocialMediaService)
    this.socialMediaService.schedulePost(postData)
      .subscribe(response => {
        alert('Post scheduled successfully!');
      });
     // Logic to schedule a post (use WorkEffortService)
    this.workEffortService.schedulePost(this.content.id, this.selectedWorkEffortType, new Date(`${this.scheduledDate}T${this.scheduledTime}:00`)).subscribe(response => {
      // Handle success
      console.log('Post scheduled:', response);
    });
  }
}

